import { PageHeader, Radio, RadioChangeEvent } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import { useMemoizedFn } from 'ahooks';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParentOrg } from './useParentOrg';

import CtAdminTable from './CtAdminTable';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { ContactLevelEnum, EMPTY_CONTACT } from 'domains/orgDomain';
import CtItemForm from './CtItemForm';
import AddrItemForm from './AddrItemForm';
import { RevxButton } from 'components/RevxButton';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { absPathRender } from 'utils/misc';

const CtAdmin = () => {
  const { t } = useTranslation();
  const parentOrg = useParentOrg();
  const dispatch = useAppDispatch();

  const curContact = useAppSelector((state) => state.org.curContact);
  const curAddr = useAppSelector((state) => state.org.curAddr);

  const shareContactOrgDefault = Boolean(parentOrg?.shareContactOrgDefault);

  const [showSavedTip, setShowSavedTip] = useState(false);

  const shareContactOrgDefaultHandle = useMemoizedFn(
    async (e: RadioChangeEvent) => {
      if (!parentOrg?.id) return;
      dispatch.app.showLoading();
      try {
        await dispatch.org.updateOrgShareContactDefault({
          shareContactOrgDefault: Boolean(e.target.value),
          orgId: parentOrg.id,
        });
        setShowSavedTip(true);
        setTimeout(() => setShowSavedTip(false), 2000);
      } catch {
      } finally {
        dispatch.app.hideLoading();
      }
    }
  );

  const routes = [
    {
      path: 'platform/org',
      breadcrumbName: parentOrg?.name || t('platform.platformMenu.org'),
    },
    {
      path: '',
      breadcrumbName: t('platform.org.ct.title'),
    },
  ];

  return (
    <>
      <PageHeader
        ghost={false}
        breadcrumb={{ routes, itemRender: absPathRender }}
        className="platform-page-header"
        extra={[
          <RevxButton
            key="create"
            brandGreen
            disabled={!!curContact || !!curAddr}
            onClick={() => {
              dispatch.org.setState({
                curContact: {
                  ...EMPTY_CONTACT,
                  orgId: parentOrg?.id || 0,
                  contactLevel: ContactLevelEnum.ORG,
                  company: parentOrg?.company.name,
                },
              });
            }}
          >
            {t('platform.org.ct.form.title.create')}
          </RevxButton>,
        ]}
      />
      {Boolean(curContact) && <CtItemForm />}
      {Boolean(curAddr) && <AddrItemForm />}

      <RevxFlexLayout
        hidden={!!curContact || !!curAddr}
        style={{ padding: '12px 0' }}
      >
        <div style={{ paddingRight: 12 }}>
          {t('platform.org.ct.shareContactOrgDefault')}
        </div>
        <Radio.Group
          value={shareContactOrgDefault}
          onChange={shareContactOrgDefaultHandle}
        >
          <Radio value={true}>{t('common.yes')}</Radio>
          <Radio value={false}>{t('common.no')}</Radio>
        </Radio.Group>
        {showSavedTip && (
          <span style={{ color: '#52c41a', paddingLeft: 12 }}>
            <CheckCircleFilled style={{ marginRight: 6 }} />
            {t('common.saveSuccess')}
          </span>
        )}
      </RevxFlexLayout>

      <CtAdminTable searchValue="" />
    </>
  );
};

export default CtAdmin;
